(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mani-price-payment"] && !Shopify.designMode) return;
  try {
    // Recalcula parcelas ao trocar de variante: o Horizon só atualiza sozinho
  // o <product-price>, então copiamos este bloco do HTML que vem no evento.
  const HORIZON = {
    variantUpdateEvent: 'variant:update',
  };

  document.addEventListener(HORIZON.variantUpdateEvent, (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    document.querySelectorAll('[data-mani-price-payment]').forEach((el) => {
      const fresh = html.querySelector(`[data-mani-price-payment][data-block-id="${el.dataset.blockId}"]`);
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mani-price"] && !Shopify.designMode) return;
  try {
    // Tudo que depende de internos do Horizon fica aqui. Quebrou após update? Edite isto.
  const HORIZON = {
    variantUpdateEvent: 'variant:update',
    stickyPrice: '.sticky-add-to-cart__price',
    stickyDelayMs: 60,
  };

  function syncSticky() {
    const source = document.querySelector('[data-mani-price]');
    const target = document.querySelector(HORIZON.stickyPrice);
    if (!source || !target) return;
    target.innerHTML = source.outerHTML;
  }

  document.addEventListener(HORIZON.variantUpdateEvent, (event) => {
    const html = event.detail?.data?.html;
    if (html) {
      document.querySelectorAll('[data-mani-price]').forEach((el) => {
        const fresh = html.querySelector(`[data-mani-price][data-block-id="${el.dataset.blockId}"]`);
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    }
    setTimeout(syncSticky, HORIZON.stickyDelayMs);
  });

  if (document.readyState !== 'loading') syncSticky();
  else document.addEventListener('DOMContentLoaded', syncSticky);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mani-review-photo"] && !Shopify.designMode) return;
  try {
    // Ampliar foto: toda imagem da seção que tem um bloco "Foto com review"
  // (o mosaico de criações) abre em tela cheia ao clicar.
  (() => {
    if (window.__maniLightboxReady) return;
    window.__maniLightboxReady = true;

    /**
     * O que depende do Horizon: a classe do bloco de imagem nativo e a do
     * wrapper de seção. Se um update quebrar a ampliação, conserte aqui.
     */
    const HORIZON = {
      section: '.shopify-section',
      nativeImage: '.image-block__image',
    };

    const REVIEW = '[data-mani-review-photo]';
    const IMAGES = `${HORIZON.nativeImage}, .mani-review-photo__image`;
    const ZOOM_WIDTH = 1600;

    const icon = (d) =>
      `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;

    /** @type {HTMLDialogElement | null} */
    let dialog = null;
    /** @type {HTMLImageElement[]} */
    let gallery = [];
    let current = 0;

    /** Imagens ampliáveis de uma seção (as que não são link). */
    const imagesOf = (section) =>
      /** @type {HTMLImageElement[]} */ (
        Array.from(section.querySelectorAll(IMAGES)).filter((img) => img instanceof HTMLImageElement && !img.closest('a'))
      );

    const prepare = (root = document) => {
      root.querySelectorAll(REVIEW).forEach((photo) => {
        const section = photo.closest(HORIZON.section);
        if (!section) return;
        imagesOf(section).forEach((img) => {
          if (img.dataset.maniZoomable !== undefined) return;
          img.dataset.maniZoomable = '';
          img.tabIndex = 0;
          img.setAttribute('role', 'button');
          img.setAttribute('aria-label', img.alt ? `Ampliar foto: ${img.alt}` : 'Ampliar foto');
        });
      });
    };

    /** @param {HTMLImageElement} img */
    const largeSrc = (img) => {
      try {
        const url = new URL(img.currentSrc || img.src, location.href);
        url.searchParams.set('width', String(ZOOM_WIDTH));
        return url.toString();
      } catch (error) {
        return img.currentSrc || img.src;
      }
    };

    const build = () => {
      const el = document.createElement('dialog');
      el.className = 'mani-lightbox';
      el.setAttribute('aria-label', 'Foto ampliada');
      el.innerHTML = `
        <div class="mani-lightbox__stage">
          <img class="mani-lightbox__image" alt="">
          <p class="mani-lightbox__caption"></p>
        </div>
        <button type="button" class="mani-lightbox__btn mani-lightbox__btn--prev" data-mani-lightbox="prev" aria-label="Foto anterior">${icon('<path d="M10 3 5 8l5 5"/>')}</button>
        <button type="button" class="mani-lightbox__btn mani-lightbox__btn--next" data-mani-lightbox="next" aria-label="Próxima foto">${icon('<path d="m6 3 5 5-5 5"/>')}</button>
        <button type="button" class="mani-lightbox__btn mani-lightbox__btn--close" data-mani-lightbox="close" aria-label="Fechar">${icon('<path d="m4 4 8 8M12 4l-8 8"/>')}</button>
      `;

      el.addEventListener('click', (event) => {
        const target = /** @type {Element} */ (event.target);
        const action = target.closest('[data-mani-lightbox]')?.getAttribute('data-mani-lightbox');
        if (action === 'prev') return show(current - 1);
        if (action === 'next') return show(current + 1);
        // Fechar, ou clique em qualquer área fora da foto.
        if (action === 'close' || !target.closest('.mani-lightbox__image')) el.close();
      });

      el.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });

      document.body.appendChild(el);
      return el;
    };

    /** @param {number} index */
    const show = (index) => {
      if (!dialog || !gallery.length) return;
      current = (index + gallery.length) % gallery.length;

      const source = gallery[current];
      const image = /** @type {HTMLImageElement} */ (dialog.querySelector('.mani-lightbox__image'));
      const caption = /** @type {HTMLElement} */ (dialog.querySelector('.mani-lightbox__caption'));

      image.src = largeSrc(source);
      image.alt = source.alt || '';

      // Se a foto tem depoimento, ele acompanha a versão ampliada.
      const review = source.closest(REVIEW);
      const quote = review instanceof HTMLElement ? review.dataset.quote : '';
      const author = review instanceof HTMLElement ? review.dataset.author : '';
      caption.textContent = quote ? `“${quote}”` : '';
      if (quote && author) {
        const name = document.createElement('span');
        name.textContent = author;
        caption.appendChild(name);
      }
    };

    /** @param {HTMLImageElement} img */
    const open = (img) => {
      const section = img.closest(HORIZON.section);
      if (!section) return;

      gallery = imagesOf(section);
      dialog = dialog || build();
      dialog.toggleAttribute('data-single', gallery.length < 2);
      show(Math.max(0, gallery.indexOf(img)));
      if (!dialog.open) dialog.showModal();
    };

    document.addEventListener('click', (event) => {
      const img = /** @type {Element} */ (event.target).closest?.('[data-mani-zoomable]');
      if (img instanceof HTMLImageElement) open(img);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const img = event.target;
      if (!(img instanceof HTMLImageElement) || img.dataset.maniZoomable === undefined) return;
      event.preventDefault();
      open(img);
    });

    prepare();
    document.addEventListener('DOMContentLoaded', () => prepare());
    // Theme editor: a seção é re-renderizada a cada edição.
    document.addEventListener('shopify:section:load', (event) => prepare(/** @type {Element} */ (event.target)));
  })();
  } catch(e) { console.error(e); }
})();

})();
